import React from 'react'
import { Link } from 'react-router-dom'

const TermsText = () => {
  return (
    <div className="text-sm text-gray-300">
      By creating an account, you agree to our{' '}
      <Link to="#" className="text-purple-300 hover:text-purple-200 transition-colors duration-300">
        Terms of Service
      </Link>{' '}
      and{' '}
      <Link to="#" className="text-purple-300 hover:text-purple-200 transition-colors duration-300">
        Privacy Policy
      </Link>
    </div>
  )
}

export default TermsText